import client from "../libs/HttpClient";

class SoftwareService {
  static getSoftwareData() {
    return client.get("/software");
  }
}

export { SoftwareService };
